module.exports = __webpack_public_path__ + "static/img/logo6.72aeea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo6.png
// module id = v7+s
// module chunks = 1